
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import PostingsApi from '../../../API/shipment/postings-api';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { DateInput, Input, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader } from '../../../components/Basic/Table';
import { H1, Text } from '../../../components/Basic/WrapsStyle';
import { ANSWERS_WAREHOUSE, MAP_SKLAD_RUS, TYPE_BUTTONS, WAREHOUSES } from '../../../constans';
import { MARKETS_LIST } from '../../Shipments/Shipment';
import ShipmentLine from './Line';
import styles from './styles.module.scss';

const TABS = [
  { tab: 'Ожидает проверки', tab_code: 'check_shipment_new' },
  { tab: 'Пропик не вовремя', tab_code: 'check_shipment_pick_late' },
  { tab: 'Упаковка не вовремя', tab_code: 'check_shipment_package_late' },
  { tab: 'Неотгруз', tab_code: 'check_shipment_not_shipped' },
  { tab: 'Проверки остатка', tab_code: 'check_shipment_overage' },
  { tab: 'Докупы', tab_code: 'check_shipment_dokup' },
  { tab: 'Экспрессы', tab_code: 'check_shipment_express' },
  { tab: 'Другое', tab_code: 'check_shipment_other' },
  { tab: 'Несогласованные расхождения', tab_code: 'check_shipment_declined_variance' },
  { tab: 'Штрафы', tab_code: 'check_shipment_penalty' },
  { tab: 'Архив', tab_code: 'check_shipment_archive' },
]

const SHOPS = {
  ozon: ['Все', 'ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  yandex: ['Все', 'yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  wb: ['Все', 'wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  megamarket: ['Все', 'megamarket1', 'megamarket2'],
};

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '100px', // 6
  '200px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '250px', // 11
  '170px', // 12
  '140px', // 13
  '500px', // 14
];

const CalcMonthAgo = () => {
  const start = new Date();
  start.setTime(start.getTime() - 60 * 24 * 3600000);

  return start;
};

const CalcFeatureTwoDay = () => {
  const start = new Date();
  start.setTime(start.getTime() + 2 * 24 * 3600000);
  return start;
};

const SKLAD_LIST = ['Не выбран', ...WAREHOUSES];

const ShipmentPage = () => {
  const [show, setShow] = useState(50);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [postings, setPostings] = useState({ ids: [], byId: {} });

  const [count, setCount] = useState([]);
  const [countStock, setCountStock] = useState({});
  const [tab, setTab] = useState('Ожидает проверки');
  const [provider, changeProvider] = useState({ providerId: '' });
  const [checkAll, setCheckAll] = useState(false);
  const [sklad, setSklad] = useState(SKLAD_LIST[0]);
  const [checkupResponse, setCheckupResponse] = useState(undefined);

  const allProviders = useSelector((store) => store.providers);

  const [map, setMap] = useState({});
  const [marketMany, setMarketMany] = useState(MARKETS_LIST[0]);
  const [shopName, setShopName] = useState('Все');
  const [providers, setProviders] = useState([]);
  const [period, setPeriod] = useState({ start: CalcMonthAgo(), end: CalcFeatureTwoDay() });

  const clickCheckAll = (flag) => {
    if (flag) {
      const map_select = {};
      postings.ids.forEach((item) => {
        map_select[postings.byId[item].posting_number] = true;
      });
      setProductsSelect(map_select);
      setCheckAll(true);
    } else {
      setCheckAll(false);
      setProductsSelect({});
    }
  };


  const changeProductsSelect = (order_number) => {
    if (productsSelect[order_number]) {
      const s = productsSelect;
      delete s[order_number];
      setProductsSelect({ ...s });
    } else {
      setProductsSelect({ ...productsSelect, [order_number]: true });
    }
    //setPostingsPrint({ ...postingsPrint, [order_number]: !postingsPrint[order_number] });
  };

  const [productsSelect, setProductsSelect] = useState({});

  const user = useSelector((store) => store.user);

  const params = useMemo(() => {
    const shop_name = shopName === 'Все' ? '' : shopName;

    return {
      search: search.trim(),
      market: marketMany === 'Не выбрана' ? undefined : marketMany.toLowerCase(),
      shop: shop_name,
      providerId: provider.id,
      limit: parseInt(show),
      page,
      period: {
        startDate: period.start,
        endDate: period.end,
      },
      tab: TABS.find(t => t.tab === tab).tab_code,
      skladName: sklad === 'Все' ? undefined : MAP_SKLAD_RUS[sklad],
      filters: {
        checkupResponse: checkupResponse === 'Не выбран' ? undefined : checkupResponse,
      },
    };
  }, [search, show, page, tab, provider.id, marketMany, shopName, period, sklad, checkupResponse]);

  const loadCards = () => {
    console.log(params)
    PostingsApi.getCheckShipment({ data: params }).then((r) => {

      const byIds = {};
      const id = r.postings.map((item) => item.posting_number);
      r.postings.forEach((item) => (byIds[item.posting_number] = item));

      setPostings({ byId: byIds, ids: id });
      setMap(r.cardsMap);
      setProductsSelect({});
      setCheckAll(false);
      setCountStock(Object.entries(r.all_count).reduce((acc, [tab, count]) => {
        acc[TABS.find(t => t.tab_code === tab).tab] = count
        return acc
      }, {}))

      setCount(r.count);
    });

    return () => { };
  };

  const changePostingsIsClosed = () => {
    console.log(productsSelect)
    PostingsApi.changePostings({ data: { field: 'checkups_is_closed', postingNumbers: Object.keys(productsSelect), value: true } })
    loadCards()

  }

  const onChangeProduct = async (id, productId, field, value, action = undefined) => {
    await PostingsApi.changeProductInPosting({ data: { postingNumber: id, productId, field, value, action } }).then((r) => {
      setPostings({ ...postings, byId: { ...postings.byId, [r.posting.posting_number]: r.posting } });
    });
    loadCards();
  };

  useEffect(() => {
    loadCards();
  }, [params]);

  const onChangeTab = (n) => {
    console.log(n)
    setTab(n);
  };

  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  const isOwner = user.role === 'owner' || user.role === 'admin';
  const isAdmin = isOwner || user.role === 'user';

  return (
    <>
      <Content>
        <H1>Проверка отгрузок</H1>
        <WhiteBlock className={styles.search_block}>
          <Row className={styles.navigate_table}>
            <NavTabs
              open_tab={tab}
              getTabName={true}
              getCountStockByMap={true}
              tabs={
                isAdmin
                  ? [
                    'Ожидает проверки',
                    'Пропик не вовремя',
                    'Упаковка не вовремя',
                    'Неотгруз',
                    'Проверки остатка',
                    'Докупы',
                    "Экспрессы",
                    'Другое',
                    'Несогласованные расхождения',
                    'Штрафы',
                    'Архив',
                  ]
                  : _.compact(['Ожидает проверки', 'Неотгруз', 'Проверки остатка', 'Докупы', 'Другое', user.access_warehouse_manage ? 'Экспрессы' : null])
              }
              isNum={true}
              num={countStock}
              style_tab={styles.style_tab}
              onChange={onChangeTab}
            />
            <Row></Row>
          </Row>

          <Row className={styles.row_input}>
            {Object.keys(productsSelect).length > 0 ? (
              <Row className={styles.row_select}>
                <Row>
                  <Button
                    type={TYPE_BUTTONS.BLUE}
                    style={{ marginRight: '15px' }}
                    onClick={() => changePostingsIsClosed(true)}
                  >
                    Перенести в решено
                  </Button>

                  <Button
                    type={TYPE_BUTTONS.RED}
                    style={{ marginRight: '15px' }}
                    onClick={() => {
                      setCheckAll(false);
                      setProductsSelect({});
                      // setTimeout(setInputFocus, 1000);
                    }}
                  >
                    Очистить выбор
                  </Button>
                </Row>
              </Row>
            ) : (
              <Input
                value={search}
                // ref={inputRef}
                onBlur={(v) => setSearch(v)}
                onClickEnter={(v) => setSearch(v)}
                label="Поиск"
              />
            )}
          </Row>
          <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>
          <Row spaceBetween={true}>
            <Row style={{ height: '40px' }}>
              <Select
                label="Показать на странице"
                select={show}
                list={['20', '50', '100', '150', '200', '500', '1000']}
                onSelect={(v) => setShow(v)}
                width="150px"
                style={{ marginRight: '15px' }}
              />
              <Select
                list={MARKETS_LIST}
                select={marketMany}
                label="Площадка"
                onSelect={(v) => setMarketMany(v)}
                width={'150px'}
                style={{ marginRight: '15px' }}
              />
              <Select
                list={SHOPS[marketMany.toLowerCase()] || []}
                select={shopName}
                disabled={marketMany === MARKETS_LIST[0]}
                label="Магазин"
                onSelect={(v) => setShopName(v)}
                width={'150px'}
                style={{ marginRight: '15px' }}
              />
              <Select
                label="Поставщик"
                select={provider}
                valueFn={(p) => p.name}
                list={providers}
                width="200px"
                onSelect={(v) => changeProvider(v)}
                style={{ marginRight: '15px' }}
              />
              <Select
                list={SKLAD_LIST}
                select={sklad}
                label="Склад отгрузки"
                onSelect={(v) => setSklad(v)}
                width={'200px'}
                style={{ marginRight: '15px' }}
              />
              <Select
                label="Ответ"
                select={checkupResponse}
                list={['Не выбран', ...ANSWERS_WAREHOUSE]}
                onSelect={(v) => setCheckupResponse(v)}
                width="200px"
                style={{ marginRight: '15px' }}
              />
            </Row>
            <Row>
              <Column style={{ marginRight: '10px' }}>
                <InputLabel>Начало периода</InputLabel>
                <Row style={{ width: '130px' }}>
                  <DateInput
                    value={period.start}
                    className={styles.calendar}
                    onChange={(v) => setPeriod({ ...period, start: new Date(v) })}
                  />
                </Row>
              </Column>
              <Column style={{ marginRight: '10px' }}>
                <InputLabel>Конец периода</InputLabel>
                <Row style={{ width: '130px' }}>
                  <DateInput
                    value={period.end}
                    className={styles.calendar}
                    onChange={(v) => setPeriod({ ...period, end: new Date(v) })}
                  />
                </Row>
              </Column>
            </Row>
            {/*  <Column className={styles.column_button}></Column>*/}
          </Row>
        </WhiteBlock>
        <Table styles={styles.table}>
          <TableHeader whiteHeader>
            <HeaderTitle width={WIDTH_POSTING[9]}>
              <CheckButton checked={checkAll} onSelect={(v) => clickCheckAll(v)} />
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[0]}>Номер заказа</HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>
              Дата отгрузки
            </HeaderTitle>

            <HeaderTitle width={WIDTH_POSTING[1]}>Позиции в заказе</HeaderTitle>
            {tab === 'Проверки остатка' && (
              <>
                <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                  Статус товара
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>
                  Занесено по заказу
                </HeaderTitle>
              </>
            )}

            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
              Причина проверки
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[5]} centerText={true}>
              Дата прихода
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[3]} centerText={true}>
              Коммент скк
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[11]} centerText={true}>
              Ответ
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[11]} centerText={true}>
              Разбор полетов
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[3]} centerText={true}>
              Статус
            </HeaderTitle>
          </TableHeader>
          {postings.ids.map((order) => {
            return (
              <ShipmentLine
                isAdmin={isAdmin}
                tab={tab}
                type={'Отгрузки'}
                order={postings.byId[order]}
                map={map}
                changeProductsSelect={changeProductsSelect}
                productsSelect={productsSelect}
                key={postings.byId[order].posting_number}
                onChangeProduct={onChangeProduct}
              />
            );
          })}
        </Table>
      </Content>
    </>
  );
};

export default ShipmentPage;
